<template>
  <BaseForm
    :title="formTitle"
    :formData="companyInfoData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue';
import axios from 'axios';

export default {
  components: {
    BaseForm
  },
  props: {
    companyInfoId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      companyInfoData: {
        name: '',
        address_line1: '',
        address_line2: '',
        city: '',
        state: '',
        zip_code: '',
        office_phone: '',
        cell_phone: '',
        fax: '',
        email: ''
      },
      fields: [
        { model: 'name', label: 'Company Name', required: true, type: 'text' },
        { model: 'address_line1', label: 'Address Line 1', type: 'text' },
        { model: 'address_line2', label: 'Address Line 2', type: 'text' },
        { model: 'city', label: 'City', type: 'text' },
        { model: 'state', label: 'State', type: 'text' },
        { model: 'zip_code', label: 'Zip Code', type: 'text' },
        { model: 'office_phone', label: 'Office Phone', type: 'text' },
        { model: 'cell_phone', label: 'Cell Phone', type: 'text' },
        { model: 'fax', label: 'Fax', type: 'text' },
        { model: 'email', label: 'Email', type: 'email' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.companyInfoId ? `Edit Company Information` : 'Add Company Information';
    },
    submitUrl() {
      return this.companyInfoId ? `/api/v1/company_info/company_info/${this.companyInfoId}/` : '/api/v1/company_info/company_info/';
    },
    method() {
      return this.companyInfoId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.companyInfoId) {
      this.loadCompanyInfoData();
    }
  },
  methods: {
    loadCompanyInfoData() {
      axios.get(`/api/v1/company_info/company_info/${this.companyInfoId}/`).then(response => {
        console.log(response.data)
        this.companyInfoData = response.data;
      }).catch(console.error);
    },
    handleSuccess() {
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Company information saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError(error) {
      console.error(error);
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving the company information!',
        icon: 'check_circle',
        timeout: 3000
      });
    }
  }
};
</script>
